import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-dropdown-menu-tab-view',
  templateUrl: './dropdown-menu-tab-view.component.html',
  styleUrls: ['./dropdown-menu-tab-view.component.css']
})
export class DropdownMenuTabViewComponent implements OnInit {

  @Input() labelOne : any
  @Input() labelTwo : any
  @Input() labelOneBadge : any
  @Input() labelTwoBadge : any
  @ViewChild(MatTabGroup, { static: false }) tabGroup!: MatTabGroup;


  constructor() { 
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // hacky solution to get the ink bar to draw the initial underline:
    timer(2500)
      .pipe(take(1))
      .subscribe(() => this.tabGroup.realignInkBar());
  }

}

